import React, {useState} from "react";
import {useSelector, useDispatch} from "react-redux";
import useOnClickOutside from "use-onclickoutside";

import * as actionTypes from "../../store/actions/actionTypes";
import * as modalActions from "../../store/actions/modal";
import {resendSms} from "../../store/actions/admission";
import {useToasts} from "react-toast-notifications";
import UrDt from "../CustomLogic/UrDt";
import AdmDt from "../CustomLogic/AdmDt";

const ModalResendSms = () => {
    const {addToast} = useToasts();
    const {show, admission, message} = useSelector(state => state.modal.resendSms);
    const {devSmsTarget_enable, devSmsTarget_phone} = useSelector(state => state.auth);
    // const [sendClicked, setSendClicked] = useState(false);

    const dispatch = useDispatch();
    const ref = React.useRef(null);
    useOnClickOutside(ref, () => hideModal());

    const hideModal = () => dispatch({type: actionTypes.MODAL_RESEND_SMS_HIDE});

    const doResend = () => {
        // setSendClicked(true);
        dispatch(resendSms(admission, addToast));
    }

    const showTargetPhone = () => {
        if (devSmsTarget_enable) {
            return (
                <dd><strike>{admission.mobilePhone}</strike> <span className="badge badge-danger">DEV TARGET ENABLED = {devSmsTarget_phone}</span></dd>
            );
        } else {
            return (
                <dd>{admission.mobilePhone}</dd>
            );
        }
    }

    const renderModal = () => {
        return (
            <div className="modal-dialog" role="document" ref={ref}>
            <div className="modal-content modal-content-fit">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={hideModal}>
                    <span aria-hidden="true">×</span>
                </button>
                <div className="modal-body">
                    <h3>Resend SMS for {admission.title} {admission.surname}, {admission.name}</h3>
                    <dl className="person-list mb-3">
                        <UrDt admission={admission}/>
                        <AdmDt admission={admission}/>
                        <dt>Mobile</dt>
                        {showTargetPhone()}
                    </dl>
                    <form action="#" className="person-info-form">
                        <div className="form-group mb-4">
                            Message <br />
                            <textarea className="form-control" disabled={true} cols="30" rows="5">{admission.enablePatientPortalMessage}</textarea>
                        </div>
                        <div className="form-group">
                            <div className="row">
                                <div className="col-12 d-flex justify-content-end">
                                    <input type="button" value="Resend SMS" className="btn btn-primary" onClick={doResend}/>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        );
    }

    return (
        <>
            <div className={`modal fade ${show ? 'show' : ''}`} id="personModal" tabIndex="-1" role="dialog"
                 aria-labelledby="personModalLabel" aria-modal="true">
                {show && renderModal()}
            </div>
        </>
    );
}

export default ModalResendSms;